import { selectMaxRulePosition } from '../rules/selectors.rules';

export function selectConditions(state) {
  return state.conditions
    .sort((a, b) => a.get('name', '').localeCompare(b.get('name')))
    .toList()
    .toJS();
}

export function selectCondition(state, conditionId) {
  const condtion = state.conditions.get(conditionId);
  if (!condtion) return undefined;
  const afterPosition = selectMaxRulePosition(state, conditionId);
  return {
    ...condtion.toJS(),
    afterPosition,
  };
}
